import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { replace } from 'gatsby';

const useRedirectMobile = (exceptPaths) => {
  const { pathname } = typeof window !== 'undefined' ? window.location : '';

  useEffect(() => {
    if (isMobile && (exceptPaths.indexOf(pathname) === -1) && pathname.indexOf('/m/') !== 0) {
      const pagePath = `/m${pathname}`;
      replace(pagePath);
    }
  }, [pathname]);
};

export default useRedirectMobile;
